/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-07-09 17:26:55
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-07-09 17:34:30
 */
import { useState, useRef, Dispatch } from 'react'
import actionTypes from '../../../../../constants/actionTypes'
import { formatPhotosForViewer, ViewerPhoto } from '../utils/mediaUtils'

// Viewer 组件的 ref 类型
interface ViewerRef {
  view: (index: number) => void
}

/**
 * 自定义Hook，用于处理照片预览功能
 * @param {function} dispatch - Redux dispatch函数，用于发送SET_PHOTOS action
 * @returns {object} - 包含viewerRef, viewerPhotos, activeTooltip和相关处理函数
 */
export default function usePhotoViewer(dispatch?: Dispatch<any>) {
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null)
  const viewerRef = useRef<ViewerRef | null>(null)
  const [viewerPhotos, setViewerPhotos] = useState<ViewerPhoto[]>([])

  /**
   * 处理照片预览
   * @param {Array} photos - 照片数组
   * @param {number} index - 初始显示的照片索引，默认为0
   */
  const handlePhotoPreview = (photos: string[], index = 0) => {
    // 关闭tooltip
    setActiveTooltip(null)

    // 将照片转换为ViewerV2需要的格式
    const formattedPhotos = formatPhotosForViewer(photos)

    // 更新照片列表
    setViewerPhotos(formattedPhotos)

    // 通知Redux
    if (dispatch) {
      dispatch({
        type: actionTypes.SET_PHOTOS,
        data: formattedPhotos
      })
    }

    // 打开查看器并显示指定索引的照片
    setTimeout(() => {
      if (viewerRef.current) {
        viewerRef.current.view(index)
      }
    }, 0)
  }

  return {
    viewerRef,
    viewerPhotos,
    activeTooltip,
    setActiveTooltip,
    handlePhotoPreview
  }
}
